import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingLarge} from "@khanacademy/wonder-blocks-typography";
import {ErrorMessageWrapper} from "@khan/component-error-message";

/**
 * Component that represents the visual status of the CoursesMenu query
 */
class CoursesMenuContainer extends React.Component<{
    loading: boolean;
    error: Error | null | undefined;
    children: React.ReactNode;
}> {
    render(): React.ReactNode {
        const {loading, error, children} = this.props;

        if (loading) {
            return (
                <View style={styles.loadingErrorWrapper}>
                    <CircularSpinner size="medium" />
                </View>
            );
        }
        if (error) {
            return (
                <View style={styles.loadingErrorWrapper}>
                    <ErrorMessageWrapper>
                        <HeadingLarge>
                            {t`Oops. Something went wrong. Please try again.`}
                        </HeadingLarge>
                    </ErrorMessageWrapper>
                </View>
            );
        }
        return children;
    }
}

const styles = StyleSheet.create({
    loadingErrorWrapper: {
        justifyContent: "center",
        paddingBottom: spacing.xxLarge_48,
        paddingTop: spacing.xxLarge_48,
    },
});

export default CoursesMenuContainer;
